/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ error: NonNullable<unknown> }} Video_Export_Alpha_Failed_ToastInputs */

const en_video_export_alpha_failed_toast = /** @type {(inputs: Video_Export_Alpha_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Alpha video export failed: ${i?.error}`)
};

const fr_video_export_alpha_failed_toast = /** @type {(inputs: Video_Export_Alpha_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Echec de l'exportation video alpha : ${i?.error}`)
};

const de_video_export_alpha_failed_toast = /** @type {(inputs: Video_Export_Alpha_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Alpha-Videoexport fehlgeschlagen: ${i?.error}`)
};

const it_video_export_alpha_failed_toast = /** @type {(inputs: Video_Export_Alpha_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Esportazione video Alpha non riuscita: ${i?.error}`)
};

const ru_video_export_alpha_failed_toast = /** @type {(inputs: Video_Export_Alpha_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Экспорт альфа-канала видео не удался: ${i?.error}`)
};

const es_video_export_alpha_failed_toast = /** @type {(inputs: Video_Export_Alpha_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Error en la exportación del video alfa: ${i?.error}`)
};

const zh_cn2_video_export_alpha_failed_toast = /** @type {(inputs: Video_Export_Alpha_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Alpha 视频导出失败：${i?.error}`)
};

const ja_video_export_alpha_failed_toast = /** @type {(inputs: Video_Export_Alpha_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`アルファビデオのエクスポートに失敗しました: ${i?.error}`)
};

const hi_video_export_alpha_failed_toast = /** @type {(inputs: Video_Export_Alpha_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`अल्फा वीडियो निर्यात विफल: ${i?.error}`)
};

const pt_pt2_video_export_alpha_failed_toast = /** @type {(inputs: Video_Export_Alpha_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`A exportação do vídeo alfa falhou: ${i?.error}`)
};

/**
* | output |
* | --- |
* | "Alpha video export failed: {error}" |
*
* @param {Video_Export_Alpha_Failed_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const video_export_alpha_failed_toast = /** @type {((inputs: Video_Export_Alpha_Failed_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Video_Export_Alpha_Failed_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_video_export_alpha_failed_toast(inputs)
	if (locale === "de") return de_video_export_alpha_failed_toast(inputs)
	if (locale === "it") return it_video_export_alpha_failed_toast(inputs)
	if (locale === "ru") return ru_video_export_alpha_failed_toast(inputs)
	if (locale === "es") return es_video_export_alpha_failed_toast(inputs)
	if (locale === "zh-CN") return zh_cn2_video_export_alpha_failed_toast(inputs)
	if (locale === "ja") return ja_video_export_alpha_failed_toast(inputs)
	if (locale === "hi") return hi_video_export_alpha_failed_toast(inputs)
	if (locale === "pt-PT") return pt_pt2_video_export_alpha_failed_toast(inputs)
	return en_video_export_alpha_failed_toast(inputs)
});